import { z } from 'zod';
import { bikeSchema } from './shared';

export const fitmentMetadataSchema = z.object({
  version: z.string(),
  original_bikes: z.array(bikeSchema),
  source_bikes: z.array(bikeSchema),
  added_bikes: z.array(bikeSchema),
  updated_at: z.number(),
  disabled: z.boolean().default(false),
  review_required: z.boolean().default(false),
});
export type FitmentMetadata = z.infer<typeof fitmentMetadataSchema>;
